import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { createApp } from 'vue';

import App from './App.vue';
import router from './router';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.use(router);

const entryNode = document.querySelector('#book-an-appointment-referral');

if (!entryNode) {
	throw new Error('Missing \'book-an-appointment-referral\' entry node');
}

app.mount(entryNode);
